/* CS filters (17 okt) - small add-on for the theme's facets.js; it does not replace the AJAX engine.
   - links with [data-cs-ajax] (size row, soort chips, price presets, applied chips) load through
     FacetFiltersForm.renderPage when facets.js is present; otherwise they navigate normally
   - Filters button [data-cs-open-filters] opens #Facet-Drawer; "Wis alles" keeps q/sort_by
   - remembers the chosen shoe size (localStorage) and offers it as a pill; never applies it itself
   - keeps open groups / "Toon alle" state after facets.js re-renders the rows
   - cleans the price params of the filter forms (empty values, comma decimals) and keeps sort_by */
(function () {
  'use strict';
  if (window.csFiltersReady) return;
  window.csFiltersReady = true;
  document.documentElement.classList.add('cs-js');

  var KEY = 'cs_shoe_size';
  var openState = {};
  var moreState = {};
  var opener = null;

  function store(k, v) {
    try {
      if (v === null) localStorage.removeItem(k);
      else localStorage.setItem(k, v);
      return true;
    } catch (e) {
      return false;
    }
  }

  function read(k) {
    try {
      return localStorage.getItem(k);
    } catch (e) {
      return null;
    }
  }

  function engine() {
    var F = window.customElements && window.customElements.get('facet-filters-form');
    if (!F || typeof F.renderPage !== 'function') return null;
    var box = document.getElementById('ProductGridContainer');
    if (!box || !document.getElementById('product-grid') || !box.querySelector('.collection')) return null;
    return F;
  }

  function queryOf(href) {
    var u;
    try {
      u = new URL(href, location.href);
    } catch (e) {
      return null;
    }
    if (u.origin !== location.origin || u.pathname !== location.pathname) return null;
    var p = u.searchParams;
    p.delete('page');
    p.delete('section_id');
    var cur = new URLSearchParams(location.search).get('sort_by');
    if (!p.has('sort_by') && cur) p.set('sort_by', cur);
    return p.toString();
  }

  function load(query) {
    var F = engine();
    if (!F || query === null) return false;
    F.renderPage(query, null, true);
    return true;
  }

  function setMore(wrap, on) {
    var btn = wrap.querySelector('[data-cs-more]');
    if (wrap.classList.contains('is-open') !== on) wrap.classList.toggle('is-open', on);
    if (!btn) return;
    var txt = on ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    if (btn.getAttribute('aria-expanded') !== String(on)) btn.setAttribute('aria-expanded', String(on));
    if (txt && btn.textContent !== txt) btn.textContent = txt;
  }

  function openDrawer(btn) {
    var d = document.getElementById('Facet-Drawer');
    if (!d) return false;
    opener = btn;
    document.body.classList.add('open-cc');
    d.classList.add('active');
    var c = d.querySelector('.cs-sheet__close button');
    if (c) {
      setTimeout(function () {
        try { c.focus({ preventScroll: true }); } catch (e) { c.focus(); }
      }, 80);
    }
    return true;
  }

  /* Clicks on whitespace inside an open group must not collapse it (CollapsibleRow content click). */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.closest('.cs-facets--m .collapsible__content, .cs-facets--d .collapsible__content') &&
        !t.closest('a, button, input, label, select, textarea, summary')) {
      e.stopPropagation();
    }
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var a = t.closest('a[data-cs-ajax]');
    if (a) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (a.hasAttribute('data-cs-forget')) store(KEY, null);
      if (load(queryOf(a.href))) e.preventDefault();
      return;
    }

    var clr = t.closest('a[data-cs-clear-all]');
    if (clr) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var cur = new URLSearchParams(location.search);
      var keep = new URLSearchParams();
      ['q', 'options[prefix]', 'sort_by'].forEach(function (k) {
        if (cur.get(k)) keep.set(k, cur.get(k));
      });
      if (load(keep.toString())) e.preventDefault();
      return;
    }

    var more = t.closest('[data-cs-more]');
    if (more) {
      var wrap = more.closest('[data-cs-morewrap]');
      if (!wrap) return;
      var on = !wrap.classList.contains('is-open');
      setMore(wrap, on);
      var row = wrap.closest('collapsible-row');
      if (row && row.dataset.index) moreState[row.dataset.index] = on;
      return;
    }

    var op = t.closest('[data-cs-open-filters]');
    if (op && openDrawer(op)) e.preventDefault();
  });

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof Element) || !d.classList.contains('cs-group')) return;
    var row = d.closest('collapsible-row');
    if (row && row.dataset.index) openState[row.dataset.index] = d.open;
  }, true);

  /* Every facets.js form: drop empty price params, accept "12,50", keep the current sort. */
  document.addEventListener('formdata', function (e) {
    var f = e.target;
    var fd = e.formData;
    if (!fd || !(f instanceof Element) || !f.closest('facet-filters-form')) return;
    ['filter.v.price.gte', 'filter.v.price.lte'].forEach(function (k) {
      if (!fd.has(k)) return;
      var v = String(fd.get(k) || '').replace(/\s/g, '').replace(/[^0-9.,]/g, '');
      if (v.indexOf(',') > -1) v = v.replace(/\./g, '').replace(',', '.');
      fd.delete(k);
      if (v !== '' && !isNaN(parseFloat(v))) fd.append(k, v);
    });
    if (!fd.has('sort_by')) {
      var s = new URLSearchParams(location.search).get('sort_by');
      if (s) fd.append('sort_by', s);
    }
  }, true);

  function restore(scope) {
    if (!scope) return;
    var rows = scope.querySelectorAll('collapsible-row[data-index]');
    for (var i = 0; i < rows.length; i++) {
      var k = rows[i].dataset.index;
      var d = rows[i].querySelector('details.cs-group');
      if (d && Object.prototype.hasOwnProperty.call(openState, k) && d.open !== openState[k]) d.open = openState[k];
      var w = rows[i].querySelector('[data-cs-morewrap]');
      if (w && moreState[k]) setMore(w, true);
    }
  }

  function syncSheet() {
    var d = document.getElementById('Facet-Drawer');
    if (!d) return;
    var n = d.querySelectorAll('[data-cs-applied] .cs-chip').length;
    var c = d.querySelectorAll('[data-cs-clear-all]');
    for (var i = 0; i < c.length; i++) {
      if (c[i].hidden !== (n === 0)) c[i].hidden = n === 0;
    }
  }

  function sizes() {
    var q = document.querySelector('[data-cs-quick]');
    if (!q) return;
    var slot = q.querySelector('[data-cs-remember]');
    var on = q.querySelectorAll('a[data-cs-size][aria-current="true"]');
    if (on.length) {
      var vals = [];
      for (var i = 0; i < on.length; i++) vals.push(on[i].getAttribute('data-cs-size'));
      var prev = read(KEY);
      var v = prev && vals.indexOf(prev) > -1 ? prev : vals[0];
      if (store(KEY, v)) {
        var msg = q.querySelectorAll('[data-cs-remembered]');
        for (var j = 0; j < msg.length; j++) {
          var tpl = msg[j].getAttribute('data-tpl') || '';
          if (tpl) {
            msg[j].textContent = tpl.replace('[n]', v);
            msg[j].hidden = false;
          }
        }
      }
      if (slot) slot.hidden = true;
      return;
    }
    if (!slot) return;
    var r = read(KEY);
    var link = null;
    if (r) {
      var all = q.querySelectorAll('a[data-cs-size]');
      for (var m = 0; m < all.length; m++) {
        if (all[m].getAttribute('data-cs-size') === r) link = all[m];
      }
    }
    if (!link) {
      slot.hidden = true;
      return;
    }
    var pill = slot.querySelector('a.cs-pill');
    if (!pill) {
      pill = document.createElement('a');
      pill.className = 'cs-pill';
      pill.setAttribute('data-cs-ajax', '');
      slot.appendChild(pill);
    }
    pill.href = link.getAttribute('href');
    pill.textContent = (slot.getAttribute('data-tpl') || '[n]').replace('[n]', r);
    slot.hidden = false;
  }

  var raf = 0;
  function refresh() {
    raf = 0;
    restore(document.getElementById('Facet-Drawer'));
    restore(document.getElementById('ProductGridContainer'));
    syncSheet();
    sizes();
  }

  function schedule() {
    if (!raf) raf = window.requestAnimationFrame(refresh);
  }

  function init() {
    refresh();
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(schedule);
    var d = document.getElementById('Facet-Drawer');
    var g = document.getElementById('ProductGridContainer');
    if (d) mo.observe(d, { childList: true, subtree: true });
    if (g) mo.observe(g, { childList: true });
    if (d) {
      new MutationObserver(function () {
        var active = d.classList.contains('active');
        var btns = document.querySelectorAll('[data-cs-open-filters]');
        for (var i = 0; i < btns.length; i++) btns[i].setAttribute('aria-expanded', String(active));
        if (!active && opener && d.contains(document.activeElement)) {
          var back = document.contains(opener) ? opener : document.querySelector('[data-cs-open-filters]');
          if (back) {
            try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); }
          }
        }
        if (!active) opener = null;
      }).observe(d, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Chery Style (okt 2026): 1 of 2 producten per rij op mobiel ([data-cs-grid] in cs-grid-toggle.liquid).
   De stand staat als class cs-grid-1 op <html> (buiten #ProductGridContainer, dat facets.js vervangt). */
(function () {
  function sync() {
    var on = document.documentElement.classList.contains('cs-grid-1');
    document.querySelectorAll('[data-cs-grid]').forEach(function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cs-grid]') : null;
    if (!btn) return;
    e.preventDefault();
    var on = document.documentElement.classList.toggle('cs-grid-1');
    try { localStorage.setItem('cs_grid', on ? '1' : '2'); } catch (err) {}
    sync();
  });
  function start() {
    sync();
    var box = document.getElementById('ProductGridContainer');
    if (box && 'MutationObserver' in window) new MutationObserver(sync).observe(box, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();